import script from "./RestaurantDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./RestaurantDetails.vue?vue&type=script&setup=true&lang=js"

import "./RestaurantDetails.vue?vue&type=style&index=0&id=356968f4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356968f4"]])

export default __exports__